/** */
import { urls } from 'services/_url';
import { apiDelete, apiGet, apiPost } from 'services/_http';

/** */
const base_url = `${urls.iam}/admins`;

export const read = async (options = {}) => {
  return apiGet(`${base_url}`, { ...options });
};

export const deleteOne = async (id, options = {}) => {
  return apiDelete(`${base_url}/${id}`, { ...options });
};

export const login = async (options = {}) => {
  return apiPost(`${base_url}/login`, { ...options });
};

export const resetPassword = async (options = {}) => {
  return apiPost(`${base_url}/password/reset`, { ...options });
};

export const signup = async (options = {}) => {
  return apiPost(`${base_url}/register`, { ...options });
};
